import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

interface PdfHeaderProps {
  data: any;
}

export const PdfFooterV2: React.FC<PdfHeaderProps> = (props) => {
  const styles = StyleSheet.create({
    text: {
      fontSize: '9px',
      marginBottom: 5,
      paddingLeft: 5,
      paddingRight: 5,
      textAlign: 'center',
      fontFamily: 'Libre Franklin'
    },
    box: {
      width: '91%',
      border: '1px solid black',
      padding: 2,
      marginLeft: 40,
      flexDirection: 'row',
      justifyContent: 'space-between',
    }
  });

  return (
    <View style={styles.box}>
      <Text style={[{marginTop: 5}, styles.text]}>This Identification Form must be completed and submitted to Intealth by {props.data.submissionDeadline}</Text>
      {props.data.caseId && (<Text style={styles.text}>Case Id: {props.data.caseId}</Text>)}
    </View>
  );
};
export default PdfFooterV2;
